(function () {
  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    var value = (cents / 100).toFixed(2);
    return "R$ " + value.replace(".", ",");
  }

  function getQtyInput() {
    var selectors = [
      'input[name="quantity"]',
      'input.quantity__input',
      'quantity-input input',
      '.product-form__quantity input'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function parseBasePriceFromAccordion(acc) {
    var raw = acc.getAttribute("data-base-price");
    var cents = parseInt(raw, 10);
    return Number.isFinite(cents) ? cents : 0;
  }

  function setTierPrices(acc, basePriceCents) {
    var moneyFormat = acc.getAttribute("data-money-format") || "${{amount}}";

    var tiers = acc.querySelectorAll("[data-tier]");
    tiers.forEach(function (row) {
      var discount = parseFloat(row.getAttribute("data-discount") || "0");
      var multiplier = 1 - (discount / 100);
      var finalCents = Math.round(basePriceCents * multiplier);

      var target = row.querySelector("[data-final-price]");
      if (target) target.textContent = formatMoney(finalCents, moneyFormat);
    });
  }

  function setActiveTier(acc, qty) {
    var tiers = Array.prototype.slice.call(acc.querySelectorAll("[data-tier]"));
    tiers.forEach(function (row) { row.classList.remove("is-active"); });

    var best = null;
    tiers.forEach(function (row) {
      var minQty = parseInt(row.getAttribute("data-qty"), 10);
      if (qty >= minQty) best = row;
    });

    if (best) best.classList.add("is-active");
  }

  function getVariantPriceCentsFromPage() {
    var priceEl = document.querySelector("[data-variant-price]");

    if (priceEl && priceEl.getAttribute("data-variant-price")) {
      var cents = parseInt(priceEl.getAttribute("data-variant-price"), 10);
      if (Number.isFinite(cents)) return cents;
    }

    return null;
  }

  function init() {
    var acc = document.querySelector("[data-vb-discount-accordion]");
    if (!acc) return;

    var qtyInput = getQtyInput();
    var baseFromLiquid = parseBasePriceFromAccordion(acc);

    var currentPrice = getVariantPriceCentsFromPage();
    var basePriceCents = Number.isFinite(currentPrice) ? currentPrice : baseFromLiquid;

    setTierPrices(acc, basePriceCents);
    setActiveTier(acc, qtyInput ? parseInt(qtyInput.value || "1", 10) : 1);

    if (qtyInput) {
      qtyInput.addEventListener("input", function () {
        var qty = parseInt(qtyInput.value || "1", 10);
        if (!Number.isFinite(qty) || qty < 1) qty = 1;
        setActiveTier(acc, qty);
      });
    }

    document.addEventListener("variant:change", function () {
      var newPrice = getVariantPriceCentsFromPage();
      if (Number.isFinite(newPrice)) {
        setTierPrices(acc, newPrice);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();